import { useId } from 'react'
import { plural } from '../../lib/format'
import type { ParsedLinks } from '../../lib/links'

interface LinksFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  parsed: ParsedLinks
  placeholder: string
  hint: string
  /** Сколько ссылок можно; больше — подсказка красным. */
  max?: number
  /** Одна строка вместо textarea («Скачать Reels»). */
  single?: boolean
  /** Чем быть ссылке, если строка не подошла: «пост Instagram», «видео YouTube». */
  kindLabel: string
  autoFocus?: boolean
}

export function LinksField({
  label,
  value,
  onChange,
  parsed,
  placeholder,
  hint,
  max,
  single = false,
  kindLabel,
  autoFocus = false,
}: LinksFieldProps) {
  const id = useId()
  const count = parsed.ids.length
  const over = max !== undefined && count > max
  const field =
    'w-full rounded-lg bg-surface px-3 text-base ring-1 ring-line outline-none ring-inset focus:ring-fg/40 desk:text-sm'

  return (
    <div>
      <div className="mb-1 flex items-baseline justify-between gap-3">
        <label htmlFor={id} className="text-xs text-muted">
          {label}
        </label>
        {!single && (
          <span className={`text-xs tabular-nums ${over ? 'text-danger' : 'text-muted'}`}>
            {count} {plural(count, 'ссылка', 'ссылки', 'ссылок')}
          </span>
        )}
      </div>
      {single ? (
        <input
          id={id}
          type="url"
          inputMode="url"
          autoFocus={autoFocus}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`${field} h-11 desk:h-9`}
        />
      ) : (
        <textarea
          id={id}
          autoFocus={autoFocus}
          rows={4}
          spellCheck={false}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`${field} min-h-28 resize-y py-2 font-mono text-[13px] leading-relaxed desk:text-[12px]`}
        />
      )}
      {parsed.bad.length > 0 ? (
        <p className="mt-1.5 text-xs text-danger">
          {parsed.lines.length === 1 || single
            ? `Это не ссылка на ${kindLabel}.`
            : `Не ссылка на ${kindLabel}: ${parsed.bad.length === 1 ? 'строка' : 'строки'} ${parsed.bad.join(', ')}.`}
        </p>
      ) : over ? (
        <p className="mt-1.5 text-xs text-danger">
          Не больше {max} {plural(max ?? 0, 'ссылки', 'ссылок', 'ссылок')} за раз.
        </p>
      ) : (
        <p className="mt-1.5 text-xs text-muted">{hint}</p>
      )}
    </div>
  )
}
